import { EMPTY_OBJECT } from '../../../constants/common'
import { useContentOverflow } from '../../../hooks'
import { Avatar } from '../../Avatar'
import { EntityArchivedIcon } from '../../Entity'
import { FloatingTooltip } from '../../Floating'
import Text from '../../Text'

import { USER_MULTI_VALUE_AVATAR_SIZE } from './UserMultiValueContent.constants'

import * as styles from './UserMultiValueContent.module.css'

import UserIcon from '../../../icons/user.svg'

function UserMultiValueContent({
  Icon,
  avatarSize = USER_MULTI_VALUE_AVATAR_SIZE,
  children,
  className = styles.UserMultiValue,
  done,
  name,
  textClassName,
  tooltipDisabled,
  unread,
  user,
  ...divProps
}) {
  const { overflow, setContentOverflowRef } = useContentOverflow()

  const { archived, avatar, avatarColor, isSystem } = user || EMPTY_OBJECT

  return (
    <div {...divProps} className={className}>
      <Avatar
        Icon={isSystem ? UserIcon : Icon}
        className={styles.icon}
        color={avatarColor}
        size={avatarSize}
        src={avatar}
        text={name}
      />
      <FloatingTooltip content={name} disabled={tooltipDisabled || !overflow}>
        <Text
          className={textClassName}
          done={done}
          ref={setContentOverflowRef}
          unread={unread}
        >
          {name}
        </Text>
      </FloatingTooltip>

      <div className={styles.icons}>
        {archived ? <EntityArchivedIcon /> : null}
        {children}
      </div>
    </div>
  )
}

export default UserMultiValueContent
